function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 32.5,
  cy: 32.5,
  r: 32.5,
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#BlankPerson_svg__clip0_5189_1963)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.159 45.256a25.26 25.26 0 016.433-3.46c2.32-.846 4.79-1.27 7.408-1.27 2.619 0 5.088.423 7.408 1.27 2.32.846 4.465 2 6.433 3.46 1.44-1.583 2.581-3.414 3.423-5.496.841-2.08 1.262-4.334 1.262-6.76 0-5.133-1.804-9.504-5.413-13.113S38.133 14.474 33 14.474c-5.133 0-9.504 1.804-13.113 5.413S14.474 27.867 14.474 33c0 2.426.42 4.68 1.262 6.76.842 2.082 1.983 3.913 3.423 5.496zM33 34.736c-2.115 0-3.898-.725-5.35-2.176-1.451-1.452-2.177-3.235-2.177-5.349 0-2.114.725-3.897 2.177-5.349 1.451-1.452 3.234-2.178 5.348-2.178 2.115 0 3.898.726 5.35 2.177 1.451 1.452 2.177 3.235 2.177 5.349 0 2.114-.725 3.897-2.177 5.35-1.451 1.45-3.234 2.177-5.348 2.177zM33 55c-3.055 0-5.92-.575-8.597-1.724-2.677-1.149-5.005-2.713-6.986-4.693-1.98-1.98-3.545-4.31-4.694-6.986S11 36.055 11 33c0-3.055.575-5.92 1.723-8.597 1.15-2.677 2.714-5.005 4.694-6.986 1.98-1.98 4.31-3.545 6.986-4.694S29.945 11 33 11c3.055 0 5.92.575 8.597 1.723 2.677 1.15 5.005 2.714 6.986 4.694 1.98 1.98 3.544 4.31 4.694 6.986C54.425 27.079 55 29.945 55 33c0 3.055-.575 5.92-1.724 8.597-1.149 2.677-2.713 5.005-4.693 6.986-1.98 1.98-4.31 3.544-6.986 4.694C38.921 54.425 36.055 55 33 55zm0-3.474c2.09 0 4.105-.336 6.046-1.008 1.94-.673 3.663-1.613 5.168-2.822-1.505-1.163-3.206-2.07-5.102-2.72C37.217 44.325 35.18 44 33 44c-2.18 0-4.22.321-6.123.964-1.904.643-3.6 1.554-5.09 2.732 1.504 1.209 3.227 2.15 5.167 2.822A18.332 18.332 0 0033 51.526zm0-20.263c1.152 0 2.115-.387 2.89-1.162.775-.775 1.163-1.738 1.163-2.89 0-1.152-.388-2.116-1.163-2.89-.775-.776-1.738-1.163-2.89-1.163-1.152 0-2.115.387-2.89 1.162-.775.775-1.163 1.739-1.163 2.89 0 1.152.388 2.116 1.163 2.89.775.776 1.738 1.163 2.89 1.163z",
  fill: "#0528A0"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "BlankPerson_svg__clip0_5189_1963"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(5 5)",
  d: "M0 0h56v56H0z"
})));

function SvgBlankPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "11 11 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgBlankPerson;